export default __webpack_public_path__ + "c819dda660cf35f206158ac18d234be4.svg";